
enum ReviewTextTopicSentiment {
	VERY_POSITIVE = 'VERY_POSITIVE',
	POSITIVE = 'POSITIVE',
	NEUTRAL = 'NEUTRAL',
	NEGATIVE = 'NEGATIVE',
	VERY_NEGATIVE = 'VERY_NEGATIVE',
}

export default ReviewTextTopicSentiment;